import React from "react";
import Link from "next/link";
import Badge, { BadgeProps } from "ui/Badge/Badge";
import Tooltip, { TooltipProps } from "ui/Tooltip/Tooltip";
import Info from "assets/icons/info.svg";
import { useStore } from "store";
import { cn } from "helpers/style";
import { capitalize } from "helpers/text";
import { ROUTE_MARKETING_POLICY } from "constants/routes";
import styles from "./AdvertisementBadge.module.scss";

type Props = {
  type: "banner" | "product" | "mobileBanner";
  advertiser: string;
  shiftRight?: number;
  tooltipProps?: Pick<TooltipProps, "width" | "maxWidth">;
  className?: string;
  badgeProps?: BadgeProps;
};

const AdvertisementBadge: React.FC<Props> = ({
  type,
  advertiser,
  shiftRight,
  tooltipProps,
  className,
  badgeProps,
}) => {
  const { search, header } = useStore();

  const onSwitchRoute = () => {
    search.value && search.clear();
    header.closeAllMenus();
  };

  if (["banner", "mobileBanner"].includes(type) && !advertiser) return null;

  return (
    <span
      className={cn([
        styles.advertisementBadge,
        shiftRight && styles[`advertisementBadgeShiftRight${shiftRight}`],
        type && styles[`advertisementBadge${capitalize(type)}`],
        className,
      ])}
    >
      <Tooltip
        maxWidth={tooltipProps?.maxWidth || 327}
        placement={
          ["banner", "mobileBanner"].includes(type) ? "top-end" : "top-start"
        }
        title={
          advertiser ? (
            <div className={styles.advertisementBadgeTooltipInner}>
              <div className={styles.advertisementBadgeTooltipInnerText}>
                Рекламодатель: {advertiser}
              </div>
              <div className={styles.advertisementBadgeTooltipInnerText}>
                Мы помогаем нашим продавцам рассказать об&nbsp;их товарах
                на&nbsp;Здравсити. Для&nbsp;этого у&nbsp;нас есть разные способы
                продвижения.
              </div>
              <div
                className={cn([
                  styles.advertisementBadgeTooltipInnerText,
                  styles.advertisementBadgeTooltipInnerTextButton,
                ])}
              >
                <Link href={ROUTE_MARKETING_POLICY} onClick={onSwitchRoute}>
                  Узнать больше <span>о&nbsp;рекламе на&nbsp;Здравсити</span>
                </Link>
              </div>
            </div>
          ) : undefined
        }
        withoutOKButton
      >
        <Badge type="adv-info" {...badgeProps}>
          Реклама <Info />
        </Badge>
      </Tooltip>
    </span>
  );
};

export default AdvertisementBadge;
